import React from "react";
import { Button } from "@mantine/core";
import { renderWithLineBreaks } from "common/utils/renderWithLineBreaks";

interface MessageScreenProps {
  message: string;
  buttonLabel?: string;
  buttonBgColor: string;
  buttonTextColor: string;
  messageColor: string;
  messageSize: string;
  onClick: () => void;
}

export const MessageScreen: React.FC<MessageScreenProps> = ({
  message,
  buttonLabel,
  buttonBgColor,
  buttonTextColor,
  messageColor,
  messageSize,
  onClick,
}) => {
  // console.log(messageColor);

  return (
    <div className="flex-1 flex flex-col h-full w-full px-4 py-8">
      {/* Top spacer */}

      {/* Centered Text */}
      <div className="flex justify-center items-center">
        <h1
          style={{ color: messageColor, fontSize: messageSize }}
          className="text-center"
        >
          {renderWithLineBreaks(message)}
        </h1>
      </div>

      {/* Bottom spacer to push text to center */}
      {/* <div className="flex-grow" /> */}

      {/* Bottom Button */}
      <div className="flex justify-center mt-32">
        {buttonLabel && (
          <Button
            style={{
              backgroundColor: buttonBgColor,
              color: buttonTextColor,
              fontWeight: 100,
            }}
            onClick={onClick}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
